import { Environment } from '@lsq-frontend/remote-services/enterprise/common';
import { microfrontendsAtEnv } from './common';

export const environment = {
    production: true,
    environment: Environment.Production,
    isDemo: true,
    cloudinaryApiKey: '399957941479352',
    cognitoClientId: '',
    cognitoUserPoolId: '',
    lsqAdminCompanyKey: '00000000-0000-0000-0000-000000001000',
    alanRuudCompanyKey: '00000000-0000-0000-0000-000000000001',
    googleAnalyticsId: null,
    internalGoogleAnalyticsId: null,
    segmentKey: 'wSe1z9aSUgi8CoJcwaviQnSGIbNoRCqS',
    launchDarklyId: '5ae88a945fa4000a8d168730',
    idleTimerInSeconds: 475 * 60,
    idleModalLifespanInSeconds: 5 * 60,
    includeFinancing: true,
    notificationPollingTimerInSeconds: 60 * 60,
    httpApiDefaultServiceName: 'dashboard',
    httpApiServiceNameUrlMap: {
        dashboard: 'https://api-dashboard-demo.lsq.com',
        //Need to do this so that the demo site can make a call and get a 404 without CORS error
        //The demo financing site was removed for security and maintainability reasons
        financing: 'https://api-dashboard-demo.lsq.com',
        arApp: 'https://api-dashboard-demo.lsq.com'
    },
    mfeRemoteNameUrlMap: {
        ...microfrontendsAtEnv('demo')
    }
};
